/* Casio Watches theme — interactions */
(function () {
  'use strict';

  /* Back-to-top visibility */
  var topBtn = document.getElementById('CasioBackToTop');
  if (topBtn) {
    var onScroll = function () {
      if (window.scrollY > 400) topBtn.classList.add('is-visible');
      else topBtn.classList.remove('is-visible');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    topBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* Slider arrows */
  function bindSlider(root) {
    var track = root.querySelector('[data-casio-track]');
    if (!track) return;
    var prev = root.querySelector('[data-casio-prev]');
    var next = root.querySelector('[data-casio-next]');
    var step = function () {
      var first = track.querySelector('*');
      return first ? first.getBoundingClientRect().width + 16 : 250;
    };
    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step() * 1.2, behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step() * 1.2, behavior: 'smooth' });
    });
  }
  document.querySelectorAll('[data-casio-slider]').forEach(bindSlider);

  /* Product tabs */
  document.querySelectorAll('[data-casio-tabs]').forEach(function (root) {
    var buttons = root.querySelectorAll('[data-casio-tab]');
    var panels = root.querySelectorAll('[data-casio-panel]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-casio-tab');
        buttons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-casio-panel') === id);
        });
      });
    });
  });

  /* FAQ accordion */
  document.querySelectorAll('[data-casio-faq-item]').forEach(function (item) {
    var btn = item.querySelector('[data-casio-faq-toggle]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      item.classList.toggle('is-open');
    });
  });

  /* Reviews simple dots/auto */
  document.querySelectorAll('[data-casio-reviews]').forEach(function (root) {
    var track = root.querySelector('[data-casio-track]');
    var dots = root.querySelectorAll('[data-casio-dot]');
    if (!track) return;
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var cards = track.children;
        if (cards[i]) {
          track.scrollTo({ left: cards[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        }
        dots.forEach(function (d) { d.classList.remove('is-active'); });
        dot.classList.add('is-active');
      });
    });
  });

  /* Footer accordion (mobile) */
  document.querySelectorAll('[data-casio-foot-col]').forEach(function (col) {
    var head = col.querySelector('[data-casio-foot-head]');
    if (!head) return;
    head.addEventListener('click', function () {
      if (window.innerWidth < 990) col.classList.toggle('is-open');
    });
  });

  /* Mobile menu drawer */
  var drawer = document.querySelector('[data-casio-drawer]');
  var burger = document.querySelector('[data-casio-burger]');
  if (drawer && burger) {
    var openDrawer = function () { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    var closeDrawer = function () { drawer.classList.remove('is-open'); document.body.style.overflow = ''; };
    burger.addEventListener('click', openDrawer);
    drawer.querySelectorAll('[data-casio-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
  }
})();
